<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="text-button">
          <!-- {{ company.name }}  -->
          <product-image
            type="companyId"
            :maxHeight="maxHeight"
            :maxWidth="maxWidth"
            :companyId="parseInt(getCompanyAttribute('tid'))"
            class=""
          />

          <!-- <v-icon small>
            mdi-information-outline
          </v-icon> -->
        </div>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-card-title>{{ getCompanyAttribute("name") }}</v-card-title>
            <!-- <product-image 
                :fileString="getCompanyAttribute('logo')" 
                type="softCompany"
                :maxWidth="100"
                :maxHeight="60"
                /> -->

            <!-- <v-list-item-content>
              <v-list-item-title>{{ company.name }}</v-list-item-title>
            </v-list-item-content> -->

            <v-list-item-action>
              <v-btn :class="fav ? 'red--text' : ''" icon @click="fav = !fav">
                <v-icon>mdi-heart</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-text>
          <product-image
            :fileString="getCompanyAttribute('logo')"
            type="softCompany"
            :maxWidth="100"
            :maxHeight="60"
          />

          <v-card-title>{{ getCompanyAttribute("name") }}</v-card-title>
          <p v-show="getCompanyAttribute('url')">
            <v-icon>mdi-web</v-icon> {{ getCompanyAttribute("url") }}
          </p>
          <p v-show="getCompanyAttribute('email')">
            <v-icon>mdi-at</v-icon> {{ getCompanyAttribute("email") }}
          </p>
          <p>{{ getCompanyAttribute("desc") }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="menu = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ProductImage from "./ProductImage";

export default {
  name: "CompanyPopup",
  components: {
    ProductImage,
  },
  props: {
    company: {
      type: Object,
      default: function () {
        return { name: null, logo: null, website: null, email: null };
      },
    },
    maxWidth: {
      type: Number,
      default: 150,
    },
    maxHeight: { type: Number, default: 40 },
  },
  data: function () {
    return {
      menu: false,
      fav: true,
    };
  },
  methods: {
    getCompanyAttribute(attr) {
      if (!this.company) return null;
      return this.company[attr];
    },
  },
  computed: {},
};
</script>

<style scoped></style>
